import { render, staticRenderFns } from "./ServicesRegion.vue?vue&type=template&id=6b51be70&"
import script from "./ServicesRegion.vue?vue&type=script&lang=js&"
export * from "./ServicesRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports